export const LANGUAGE_KEY = "language";
export const APP_API = "https://cms.easylaser.vn";
// export const APP_API = "http://localhost:1337";
